import { render } from "./TabCustomfields.vue?vue&type=template&id=42fe5126&scoped=true"
import script from "./TabCustomfields.vue?vue&type=script&lang=js"
export * from "./TabCustomfields.vue?vue&type=script&lang=js"

import "./TabCustomfields.vue?vue&type=style&index=0&id=42fe5126&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42fe5126"]])

export default __exports__